import Clipboard from 'clipboard/dist/clipboard.min.js';

export default function (el) {
  const button = el.find('.btn');
  const clipboard = new Clipboard(button[0]);

  clipboard.on('success', (e) => {
    showTooltip(e.trigger, 'Copied!');
  });

  button.on('mouseleave', (e) => {
    e.currentTarget.classList.remove('tooltipped', 'tooltipped-s');
    e.currentTarget.removeAttribute('aria-label');
  });

  const showTooltip = function (elem, msg) {
    elem.classList.add('tooltipped', 'tooltipped-s');
    elem.setAttribute('aria-label', msg);
  };
}
